import type { MapleMarketCategory } from '@/data/mapleMarketApps';

interface MapleMarketCategoryBarProps {
  active: MapleMarketCategory | 'All';
  categories: { name: MapleMarketCategory; icon: string; count: number }[];
  onChange: (category: MapleMarketCategory | 'All') => void;
}

export default function MapleMarketCategoryBar({ active, categories, onChange }: MapleMarketCategoryBarProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
      <button
        type="button"
        onClick={() => onChange('All')}
        className={`h-9 shrink-0 rounded-lg border px-4 text-sm font-medium transition-all ${
          active === 'All'
            ? 'border-primary/30 bg-primary text-primary-foreground shadow-sm'
            : 'border-transparent bg-secondary text-secondary-foreground hover:border-border hover:bg-accent'
        }`}
      >
        All
      </button>
      {categories.map((category) => (
        <button
          key={category.name}
          type="button"
          onClick={() => onChange(category.name)}
          className={`flex h-9 shrink-0 items-center gap-1.5 rounded-lg border px-4 text-sm font-medium transition-all ${
            active === category.name
              ? 'border-primary/30 bg-primary text-primary-foreground shadow-sm'
              : 'border-transparent bg-secondary text-secondary-foreground hover:border-border hover:bg-accent'
          }`}
        >
          <span>{category.icon}</span>
          <span>{category.name}</span>
          <span className={`text-xs ${active === category.name ? 'text-primary-foreground/80' : 'opacity-75'}`}>
            {category.count}
          </span>
        </button>
      ))}
    </div>
  );
}